export const handleSchedulerTypes = (type) => {
  const types = {
    "Dramaturgia Longa": "Capítulos/Sinopse",
    "Dramaturgia Curta": "Materiais",
    Variedades: "Materiais",
  };
  return types[type];
};
